/*
 * Shared feed code: used by the React app (src/feed) AND the Cloud Functions
 * (copied to functions/src/shared by `npm --prefix functions run sync`).
 * Keep these files free of browser/Node-only APIs and use explicit .js
 * extensions on relative imports (required by Node ES modules).
 */

// 'https://baws.in/books/x' or 'baws.in/books/x' -> '/books/x'
export function toAppPath(url) {
  if (!url) return null;
  const m = /^(?:https?:\/\/)?(?:www\.)?baws\.in(\/.*)?$/i.exec(url);
  if (m) return m[1] || '/';
  if (url.startsWith('/')) return url;
  return null;
}

// https URL -> { u: URL, host: 'example.com' } (www./m./mobile. stripped)
export function parseHost(url) {
  try {
    const u = new URL(url);
    if (u.protocol !== 'https:') return null;
    return { u, host: u.hostname.replace(/^(www\.|m\.|mobile\.)/, '') };
  } catch (e) {
    return null;
  }
}

export const domainOf = (url) => parseHost(url)?.host || '';

// '/books/baws/EN/Volume_01/pdf/38' -> { path, bookParent, language,
// bookName, pageNo: 38, label: 'Volume 01 · Page 38' }; null for other links.
export function parseBookPage(link) {
  const path = toAppPath(link);
  const m = /^\/books\/([^/?#]+)\/([^/?#]+)\/([^/?#]+)\/pdf\/(\d+)$/.exec(
    path || ''
  );
  if (!m) return null;
  const [, bookParent, language, bookName, page] = m;
  const pageNo = Number(page);
  return {
    path,
    bookParent,
    language,
    bookName,
    pageNo,
    label: `${bookName.replace(/_/g, ' ')} · Page ${pageNo}`,
  };
}
